import { render, staticRenderFns } from "./MarkCustomer.vue?vue&type=template&id=f8828d12&"
import script from "./MarkCustomer.vue?vue&type=script&lang=js&"
export * from "./MarkCustomer.vue?vue&type=script&lang=js&"
import style0 from "./MarkCustomer.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports